import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_24 } from '../../../Button'
import { QA_NAME_DASHBOARD_BIRDVIEW_RETRY } from '../../DashboardBirdview.constants.qa'
import { BirdviewCardPlaceholder } from '../BirdviewCardPlaceholder'

function BirdviewCardError({ onRetry }) {
  const { t } = useTranslation()

  return (
    <BirdviewCardPlaceholder>
      {t('DashboardBirdview.SectionLoadErrorKey')}
      <Button.Text
        isInline
        height={BUTTON_HEIGHT_24}
        qaName={QA_NAME_DASHBOARD_BIRDVIEW_RETRY}
        text={t('DashboardBirdview.RetryKey')}
        onClick={onRetry}
      />
    </BirdviewCardPlaceholder>
  )
}

export default BirdviewCardError
